var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA114Ac1575E0303158Ba016F7B07B5Da56979D66(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 21.3333 26.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0C4.77563 0 0 5.33678 0 11.3333C0 17.2829 3.40443 23.7499 8.71609 26.2326C9.95432 26.8114 11.379 26.8114 12.6172 26.2326C17.9289 23.7499 21.3333 17.2829 21.3333 11.3333C21.3333 5.33678 16.5577 0 10.6667 0ZM10.6667 13.3333C12.1394 13.3333 13.3333 12.1394 13.3333 10.6667C13.3333 9.19391 12.1394 8 10.6667 8C9.19391 8 8 9.19391 8 10.6667C8 12.1394 9.19391 13.3333 10.6667 13.3333Z",
    fill: "var(--fill-0, white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA114Ac1575E0303158Ba016F7B07B5Da56979D66);
export default __webpack_public_path__ + "static/media/a114ac1575e0303158ba016f7b07b5da56979d66.fae9fe82cac02e11230b1c80492fab49.svg";
export { ForwardRef as ReactComponent };